'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AccountPreferences$$anon$17(ps$12) {
  this.a6w = null;
  this.a6w = ps$12;
}
export { $c_Lmealorama_AccountPreferences$$anon$17 as $c_Lmealorama_AccountPreferences$$anon$17 };
$p = $c_Lmealorama_AccountPreferences$$anon$17.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AccountPreferences$$anon$17;
/** @constructor */
function $h_Lmealorama_AccountPreferences$$anon$17() {
}
export { $h_Lmealorama_AccountPreferences$$anon$17 as $h_Lmealorama_AccountPreferences$$anon$17 };
$h_Lmealorama_AccountPreferences$$anon$17.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6w.a.length;
});
$p.g = (function(i) {
  return this.a6w.a[i];
});
var $d_Lmealorama_AccountPreferences$$anon$17 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AccountPreferences$$anon$17, "mealorama.AccountPreferences$$anon$17", ({
  Fh: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_AccountPreferences$$anon$17 as $d_Lmealorama_AccountPreferences$$anon$17 };
//# sourceMappingURL=mealorama.-Account-Preferences$$anon$17.js.map
